export const BACKEND_URL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
export const DEEP_URL = `http://14.45.108.69:7070`;

var instance = null;

export default class DataSender {
  constructor() {
    if (instance) return instance;
    instance = this;
  }

  async errorHandle(response) {
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response;
  }

  getHeader(method, data) {
    return {
      method,
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Cache: "no-cache",
      },
      credentials: "include",
      body: JSON.stringify(data),
    };
  }

  access(primary_key) {
    return fetch(
      `${BACKEND_URL}/access`,
      this.getHeader("POST", { primary_key })
    );
  }

  accessPhone(phone_number) {
    return fetch(
      `${BACKEND_URL}/access/phone`,
      this.getHeader("POST", { phone_number })
    ).then(this.errorHandle);
  }

  accessDt(dt_number) {
    return fetch(
      `${BACKEND_URL}/access/dt`,
      this.getHeader("POST", { dt_number })
    ).then(this.errorHandle);
  }

  health(data) {
    return fetch(
      `${BACKEND_URL}/access/health`,
      this.getHeader("POST", data)
    ).then(this.errorHandle);
  }

  unitLst() {
    return fetch(`${BACKEND_URL}/access/unit`, this.getHeader("GET")).then(
      this.errorHandle
    );
  }

  insertSoldier(data) {
    return fetch(
      `${BACKEND_URL}/access/soldier`,
      this.getHeader("POST", data)
    ).then(this.errorHandle);
  }

  login(data) {
    return fetch(`${BACKEND_URL}/doLogin`, this.getHeader("POST", data)).then(
      this.errorHandle
    );
  }

  getTempeture() {
    return fetch(`${BACKEND_URL}/health_handle/`).then(this.errorHandle);
  }

  checkLogin() {
    return fetch(`${BACKEND_URL}/checkLogin`, this.getHeader("POST")).then(
      this.errorHandle
    );
  }

  logout() {
    return fetch(`${BACKEND_URL}/logout`, this.getHeader("POST")).then(
      this.errorHandle
    );
  }

  insertTrain(data) {
    return fetch(`${BACKEND_URL}/train`, this.getHeader("POST", data)).then(
      this.errorHandle
    );
  }

  getTrainHistory(type) {
    return fetch(
      `${BACKEND_URL}/train/history/${type}`,
      this.getHeader("GET")
    ).then(this.errorHandle);
  }

  getTrainPeople() {
    return fetch(`${BACKEND_URL}/train/people`, this.getHeader("GET")).then(
      this.errorHandle
    );
  }

  trainStart(data) {
    return fetch(
      `${BACKEND_URL}/train/start`,
      this.getHeader("POST", data)
    ).then(this.errorHandle);
  }

  trainStop() {
    return fetch(`${BACKEND_URL}/train/stop`, this.getHeader("POST")).then(
      this.errorHandle
    );
  }

  deleteTrain(data) {
    return fetch(
      `${BACKEND_URL}/train/delete`,
      this.getHeader("DELETE", { del: data })
    ).then(this.errorHandle);
  }
}
